if (!customElements.get('fs-primary-navigation')) {
  customElements.define('fs-primary-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.buttons = [...this.querySelectorAll('.fs-nav__toggle')];
      this.buttons.forEach(button => { button.hidden = false; });
      this.querySelectorAll('a[href]').forEach(link => {
        if (link.pathname === window.location.pathname) {
          link.setAttribute('aria-current', 'page');
          link.closest('.fs-nav__item')?.querySelector('.fs-nav__toggle')?.classList.add('fs-nav__active');
        }
      });
      this.addEventListener('click', event => {
        const button = event.target.closest('.fs-nav__toggle');
        if (!button) return;
        event.stopPropagation();
        const open = button.getAttribute('aria-expanded') !== 'true';
        this.close();
        this.setOpen(button, open);
      }, { capture: true, signal });
      this.addEventListener('keydown', event => {
        const button = event.target.closest('.fs-nav__toggle');
        if (button && event.key === 'ArrowDown') {
          event.preventDefault();
          this.close();
          this.setOpen(button, true);
          this.panel(button).querySelector('a')?.focus();
        }
        if (event.key === 'Escape' && this.buttons.some(item => item.getAttribute('aria-expanded') === 'true')) {
          event.preventDefault();
          event.stopPropagation();
          this.escapeHandled = true;
          const active = this.buttons.find(item => item.getAttribute('aria-expanded') === 'true');
          this.close();
          active?.focus();
        }
      }, { signal });
      this.addEventListener('keyup', event => {
        if (event.key === 'Escape' && this.escapeHandled) {
          event.stopPropagation();
          this.escapeHandled = false;
        }
      }, { signal });
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) this.close();
      }, { signal });
      this.addEventListener('focusout', () => {
        if (this.dataset.mode === 'desktop') requestAnimationFrame(() => {
          if (!this.contains(document.activeElement)) this.close();
        });
      }, { signal });
      const media = window.matchMedia('(min-width: 1280px)');
      media.addEventListener('change', () => {
        this.close();
        if (media.matches && this.dataset.mode === 'drawer') {
          const drawer = this.closest('header-drawer');
          const summary = drawer?.querySelector(':scope > details > summary');
          if (drawer?.querySelector(':scope > details[open]')) drawer.closeMenuDrawer(new Event('resize'), summary);
        }
      }, { signal });
      const drawerDetails = this.closest('#Details-menu-drawer-container');
      drawerDetails?.addEventListener('toggle', () => { if (!drawerDetails.open) this.close(); }, { signal });
    }
    panel(button) { return this.querySelector(`#${CSS.escape(button.getAttribute('aria-controls'))}`); }
    setOpen(button, open) {
      button.setAttribute('aria-expanded', String(open));
      this.panel(button).hidden = !open;
      const sticky = this.closest('sticky-header');
      if (sticky) sticky.preventHide = this.buttons.some(item => item.getAttribute('aria-expanded') === 'true');
    }
    close() { this.buttons.forEach(button => this.setOpen(button, false)); }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
